import { IRbac } from '../../apis/__shared/rbac.interfaces';

export const mockRbacTeacher: IRbac = {
  dashboard: {
    finance: {
      read: false,
      write: false,
      delete: false,
    },
    people: {
      read: true,
      write: false,
      delete: false,
    },
    events: {
      read: true,
      write: true,
      delete: false,
    },
  },
  students: {
    studentList: {
      read: true,
      write: false,
      delete: false,
    },
    attendance: {
      read: true,
      write: true,
      delete: false,
    },
    fees: {
      read: false,
      write: false,
      delete: false,
    },
    events: {
      read: true,
      write: true,
      delete: false,
    },
    scores: {
      read: true,
      write: true,
      delete: false,
    },
    documents: {
      read: true,
      write: false,
      delete: false,
    },
  },
  staff: {
    staffList: {
      read: true,
      write: false,
      delete: false,
    },
    attendance: {
      read: false,
      write: false,
      delete: false,
    },
    payouts: {
      read: false,
      write: false,
      delete: false,
    },
    events: {
      read: true,
      write: true,
      delete: false,
    },
    documents: {
      read: false,
      write: false,
      delete: false,
    },
  },
  academics: {
    curriculum: {
      read: true,
      write: false,
      delete: false,
    },
    schedules: {
      read: true,
      write: false,
      delete: false,
    },
    lessonPlans: {
      read: true,
      write: true,
      delete: true,
    },
    materials: {
      read: true,
      write: true,
      delete: true,
    },
    assessments: {
      read: true,
      write: true,
      delete: true,
    },
    library: {
      read: true,
      write: false,
      delete: false,
    },
  },
  communications: {
    messaging: {
      read: true,
      write: true,
      delete: true,
    },
    announcements: {
      read: true,
      write: true,
      delete: false,
    },
    concerns: {
      read: true,
      write: true,
      delete: false,
    },
    events: {
      read: true,
      write: true,
      delete: false,
    },
    meetings: {
      read: true,
      write: true,
      delete: false,
    },
  },
  finance: {
    financeList: {
      read: false,
      write: false,
      delete: false,
    },
    scholarships: {
      read: false,
      write: false,
      delete: false,
    },
    financialReports: {
      read: false,
      write: false,
      delete: false,
    },
  },
  analytics: {
    performance: {
      read: true,
      write: false,
      delete: false,
    },
    customDashboards: {
      read: false,
      write: false,
      delete: false,
    },
  },
  administration: {
    transport: {
      read: false,
      write: false,
      delete: false,
    },
    inventory: {
      read: false,
      write: false,
      delete: false,
    },
    healthAndSafety: {
      read: true,
      write: true,
      delete: false,
    },
  },
  users: {
    parents: {
      read: true,
      write: false,
      delete: false,
    },
    visitors: {
      read: false,
      write: false,
      delete: false,
    },
    guests: {
      read: false,
      write: false,
      delete: false,
    },
  },
  settings: {
    userManagement: {
      read: false,
      write: false,
      delete: false,
    },
    complianceManagement: {
      read: false,
      write: false,
      delete: false,
    },
  },
  profile: {
    personalDetails: {
      read: true,
      write: true,
      delete: false,
    },
    documents: {
      read: true,
      write: true,
      delete: true,
    },
    calendar: {
      read: true,
      write: true,
      delete: true,
    },
    leaves: {
      read: true,
      write: true,
      delete: false,
    },
  },
  guardian: {
    dashboard: { read: false, write: false, delete: false },
    academicsSchedule: { read: false, write: false, delete: false },
    academicsCurriculum: { read: false, write: false, delete: false },
    academicsLessonPlans: { read: false, write: false, delete: false },
    academicsMaterials: { read: false, write: false, delete: false },
    academicsAssessments: { read: false, write: false, delete: false },
    academicsHomework: { read: false, write: false, delete: false },
    academicsAttendance: { read: false, write: false, delete: false },
    academicsLibrary: { read: false, write: false, delete: false },
    fees: { read: false, write: false, delete: false },
    transport: { read: false, write: false, delete: false },
    documents: { read: false, write: false, delete: false },
    eventsCommunication: { read: false, write: false, delete: false },
    concerns: { read: false, write: false, delete: false },
    profile: { read: false, write: false, delete: false },
    settings: { read: false, write: false, delete: false },
  },
};
